export default class ContractGroupFilterBind {
  customerName: string;

  cnpj: string;

  externalId: string;

  status: string;

  beneficiary: string;

  constructor(obj: any) {
    this.customerName = obj.customerName || '';
    this.cnpj = obj.cnpj || '';
    this.externalId = obj.externalId || '';
    this.status = obj.status || '';
    this.beneficiary = obj.beneficiary || '';
  }

  public static of(obj: any): ContractGroupFilterBind {
    return new ContractGroupFilterBind(obj || {});
  }
}
